import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { useAuth } from '../../context/AuthContext';
import { VistaDeSuplementos } from '../../pages/SupplementsPage';

/**
 * «ASÍ VERÁ LA SUPLEMENTACIÓN EL CLIENTE» (hoja del 21-10, fila 32), al final de la pestaña
 * Suplementos de la ficha. Es SU pantalla, la de verdad (`VistaDeSuplementos`), con lo que
 * tiene guardado: lo que se está editando arriba no sale hasta que se guarda, porque el
 * cliente tampoco lo ve antes. Se vuelve a pedir cada vez que la ficha se recarga, que es lo
 * que pasa al guardar o al borrar una versión (`refresco`).
 *
 * Solo para mirar: va `inert`, así que ni los enlaces de las tiendas ni el botón de pago de
 * la guía hacen nada desde aquí.
 */
const AsiLoVeElCliente = ({ api, clientId, refresco }) => {
    const { pantalla } = useAuth();
    const nuevo = pantalla('t2_suplementos', true);
    const [vista, setVista] = useState(null);
    const [fallo, setFallo] = useState(false);

    useEffect(() => {
        let vivo = true;
        setFallo(false);
        api.get(`/admin/supplements/vista-cliente?client_id=${clientId}`)
            .then(r => { if (vivo) setVista(r.data); })
            .catch((e) => {
                console.error('No se pudo traer la vista del cliente:', e);
                if (vivo) setFallo(true);
            });
        return () => { vivo = false; };
    }, [api, clientId, refresco]);

    return (
        <Card className="bg-white border-[#E5E2DB]" data-testid="sup-asi-lo-ve">
            <CardHeader className="pb-2">
                <CardTitle className="text-sm text-[#6F6B64] uppercase tracking-wider">
                    Así verá la suplementación el cliente
                </CardTitle>
            </CardHeader>
            <CardContent>
                {fallo ? (
                    <p className="text-sm text-[#57544E]">No se pudo cargar cómo lo ve el cliente.</p>
                ) : !vista ? (
                    <Loader2 className="w-4 h-4 animate-spin text-[#6F6B64]" />
                ) : !vista.ve_la_pantalla ? (
                    <p className="text-sm text-[#57544E]" data-testid="sup-asi-lo-ve-sin-pantalla">
                        No la ve: su plan no incluye suplementación o no tiene el acceso activo.
                    </p>
                ) : (
                    // Nunca más estrecha que un móvil: en la ficha del móvil quedan unos 300 px y
                    // las tarjetas se cortaban, cosa que al cliente no le pasa. Por debajo de
                    // eso se desplaza de lado dentro del recuadro, no la página.
                    <div className="rounded-xl border border-border bg-background overflow-x-auto">
                        <div inert className="min-w-[375px]" data-testid="sup-asi-lo-ve-pantalla">
                            <VistaDeSuplementos api={api} protocol={vista.protocolo} guia={vista.guia}
                                numComidas={vista.num_comidas} nuevo={nuevo} />
                        </div>
                    </div>
                )}
            </CardContent>
        </Card>
    );
};

export default AsiLoVeElCliente;
